module.exports = __webpack_public_path__ + "img/train2.d56041d4.jpeg";